import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState, store } from "../redux/store";
import { getTokenExpiration, refreshToken } from "../lib/utils";
import { clearToken, setToken } from "../redux/slices/authSlice";
import { BASE_API_URL } from "../lib/constants";

const endpointsWithoutTokenHeader = ["registerUser", "authenticateUser"];
export const emptySplitBaseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}`,
    prepareHeaders: async (headers, { endpoint, getState }) => {
      const state = getState() as RootState;
      const token = state.auth?.token;
      const email = state.auth?.email;
      const password = state.auth?.password;
      const isLoginForVendor = state.auth?.isLoginForVendor;
      const now = Math.floor(Date.now() / 1000);

      if (token) {
        const expiration = getTokenExpiration(token);
        const expirationBuffer = 60;
        const expirationWithBuffer = expiration
          ? expiration - expirationBuffer
          : 0;
        if (expirationWithBuffer && expirationWithBuffer < now) {
          if (!email || !password) {
            store.dispatch(clearToken());
            console.log("Token expired");
            return;
          }
          try {
            const newToken = await RequestDeduplicator.request("token", () =>
              refreshToken(email, password, isLoginForVendor)
            );
            store.dispatch(setToken(newToken));
            headers.set("Authorization", `Bearer ${newToken}`);
          } catch (error) {
            console.error("Token refresh failed", error);
            store.dispatch(clearToken());
            // throw error;
          }
        } else {
          if (token && !endpointsWithoutTokenHeader.includes(endpoint)) {
            headers.set("Authorization", `Bearer ${token}`);
          }
        }
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
  refetchOnReconnect: true, // Refetch data when the browser reconnects
  refetchOnMountOrArgChange: true, // Refetch when component remounts or args change
});

export class RequestDeduplicator {
  private static requests: Record<string, Promise<any>> = {};

  static async request<T>(key: string, func: () => Promise<T>): Promise<T> {
    if (!this.requests[key]) {
      this.requests[key] = func()
        .then((result) => {
          delete this.requests[key];
          return result;
        })
        .catch((error) => {
          delete this.requests[key];
          throw error;
        });
    }
    return this.requests[key];
  }
}

// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { RootState } from './store'; // Adjust the import according to your store setup
// import { logout } from './authSlice'; // Import your logout action
// import jwtDecode from 'jwt-decode';

// // Define a utility function to get token expiration
// const getTokenExpiration = (token: string): number | null => {
//   try {
//     const decoded = jwtDecode<{ exp: number }>(token);
//     return decoded.exp;
//   } catch (e) {
//     return null;
//   }
// };

// const endpointsWithoutTokenHeader = ['registerUser', 'authenticateUser'];

// // Initialize an empty API service
// export const emptySplitBaseApi = createApi({
//   baseQuery: fetchBaseQuery({
//     prepareHeaders: (headers, { endpoint, getState }) => {
//       const state: RootState = getState();
//       const token = state.auth?.token;
//       const now = Math.floor(Date.now() / 1000); // Current time in seconds

//       if (token) {
//         const expiration = getTokenExpiration(token);

//         if (expiration && expiration < now) {
//           // Token has expired, dispatch logout action
//           store.dispatch(logout());
//           // Optionally, throw an error or handle the expired token case
//           throw new Error('Token expired');
//         }

//         // Add the token to headers if it's not expired and the endpoint requires authentication
//         if (!endpointsWithoutTokenHeader.includes(endpoint)) {
//           headers.set('Authorization', `Bearer ${token}`);
//         }
//       }

//       return headers;
//     },
//   }),
//   endpoints: () => ({}),
// });
